import React from "react";
import "./Border.scss";

const Border: React.FunctionComponent<any> = ({className}) => {
  return <div className={`Border ${className}`}><div /></div>
}

export default Border;
